import { ACCESSIBILITY_COLOR_MODES } from 'config/accessibilityTheme.config';
import {
  DEFAULT_ACCESSIBILITY_OPTIONS,
  DEFAULT_DISPLAY_OPTIONS,
  DEFAULT_NAVIGATION_STYLE,
} from 'store/config/displayOptions.config';
import { DEFAULT_CHART_OPTIONS } from 'utils/charts/chartStyle.utils';
import { DEFAULT_MAP_OPTIONS } from 'utils/maps/mapTile.utils';
import { normalizeAccessibilityColorMode, resolveAccessibilityTheme } from 'utils/themes/theme.utils';
import { DEFAULT_DISPLAY_THEME, resolveDisplayTheme } from 'utils/themes/theme.utils';

export const selectDisplayTheme = (state) =>
  state.displayOptions?.displayTheme || DEFAULT_DISPLAY_THEME;
export const selectNavigationStyle = (state) =>
  state.displayOptions?.navigationStyle || DEFAULT_NAVIGATION_STYLE;
export const selectMapOptions = (state) => state.displayOptions?.mapOptions || DEFAULT_MAP_OPTIONS;
export const selectChartOptions = (state) =>
  state.displayOptions?.chartOptions || DEFAULT_CHART_OPTIONS;
export const selectAccessibilityOptions = (state) =>
  state.displayOptions?.accessibilityOptions || DEFAULT_ACCESSIBILITY_OPTIONS;
export const selectResolvedDisplayTheme = (state) => {
  const accessibilityColorMode = normalizeAccessibilityColorMode(
    selectAccessibilityOptions(state).colorMode,
  );

  if (accessibilityColorMode !== ACCESSIBILITY_COLOR_MODES.DEFAULT) {
    return resolveAccessibilityTheme(accessibilityColorMode);
  }

  return resolveDisplayTheme(selectDisplayTheme(state));
};
export const selectResolvedThemeTokens = (state) => selectResolvedDisplayTheme(state).value;
export const selectPersistableDisplayOptions = (state) => ({
  ...DEFAULT_DISPLAY_OPTIONS,
  displayTheme: selectDisplayTheme(state),
  mapOptions: selectMapOptions(state),
  chartOptions: selectChartOptions(state),
  accessibilityOptions: selectAccessibilityOptions(state),
});
